import { MutableState } from '../State';
import type { AssignManualAbTestArgs } from '../ab/ab.modifiers';
import { EntryPlatform } from './entry.ruleset';

/**
 * Set the entry timestamp for a given platform.
 * @param state
 * @param platform
 * @param timestamp
 */
export function setEntryTimestamp(
  state: MutableState,
  platform: EntryPlatform,
  timestamp: number,
): void {
  if (!state.entry) {
    state.entry = {};
  }

  if (!state.entry[platform]) {
    state.entry[platform] = {
      timestamp: 0,
      previousTimestamp: 0,
    };
  }

  // Move existing timestamp to previous timestamp
  const prevTimestamp = state.entry?.[platform]?.timestamp ?? 0;
  state.entry[platform].previousTimestamp = prevTimestamp;

  // Set a new entry timestamp
  state.entry[platform].timestamp = timestamp;
}

/**
 * Set the entry timestamp to a platform based on the given arguments.
 * @param state
 * @param args
 * @param timestamp
 * @returns
 */
export function setEntryTimestampWithArgs(
  state: MutableState,
  args: AssignManualAbTestArgs,
  timestamp: number,
): void {
  if (args.isNativeIOS) {
    setEntryTimestamp(state, 'IOS_APP', timestamp);
    return;
  }

  if (args.isNativeAndroid) {
    setEntryTimestamp(state, 'ANDROID_APP', timestamp);
    return;
  }

  if (args.isPlatformLiff) {
    setEntryTimestamp(state, 'LIFF', timestamp);
    return;
  }

  // Default to web
  setEntryTimestamp(state, 'WEB', timestamp);
}
